var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockFilled = function SvgClockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.375,
    cy: 11.3,
    r: 11.177,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.497,
    d: "M11.11 3.204a.84.84 0 0 1 .928.332h.001c.091.131.138.279.155.45l.01.179q-.003 1.434-.002 2.867c0 .976.004 1.948-.004 2.921a.66.66 0 0 0 .068.313c.05.099.125.173.206.233 1.244.935 2.476 1.873 3.721 2.81q.27.205.367.433c.063.149.08.322.03.53-.144.608-.826.861-1.357.474-.697-.509-1.376-1.037-2.07-1.561-.749-.567-1.498-1.14-2.253-1.702a1 1 0 0 1-.433-.855q-.001-3.26.002-6.52c0-.247.064-.442.168-.587a.85.85 0 0 1 .463-.317Z"
  })));
};
export default SvgClockFilled;